import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

const PassengersPage = () => {
  const [passengers, setPassengers] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [search, setSearch]         = useState('');
  const [total, setTotal]           = useState(0);
  const [page, setPage]             = useState(1);
  const LIMIT = 50;

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get('/users/passengers', { params: { search, page, limit: LIMIT } });
      setPassengers(res.data.data);
      setTotal(res.data.total);
    } catch {
      setPassengers([]);
    } finally {
      setLoading(false);
    }
  }, [search, page]);

  useEffect(() => { fetch(); }, [fetch]);

  const toggleStatus = async (id, isActive) => {
    try {
      await api.patch(`/users/passengers/${id}/toggle`);
      setPassengers((p) => p.map((u) => u.id === id ? { ...u, isActive: !u.isActive } : u));
    } catch (e) {
      alert(e.response?.data?.message || 'خطأ');
    }
  };

  return (
    <div className="p-4 md:p-6 space-y-5" dir="rtl">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-gray-800">إدارة المسافرين</h1>
        <p className="text-gray-500 text-sm">إجمالي: {total} مسافر</p>
      </div>

      <div className="bg-white rounded-xl shadow p-4 flex gap-3">
        <input
          type="text" placeholder="بحث بالاسم أو البريد أو الهاتف..."
          value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {loading ? (
        <div className="text-center py-20 text-gray-400">جاري التحميل...</div>
      ) : passengers.length === 0 ? (
        <div className="text-center bg-white rounded-xl shadow py-20 text-gray-400">
          <div className="text-5xl mb-3">👥</div>
          <p>لا توجد نتائج</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[560px]">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="text-right px-4 py-3 text-gray-600 font-semibold">المسافر</th>
                <th className="text-right px-4 py-3 text-gray-600 font-semibold">الهاتف</th>
                <th className="text-center px-4 py-3 text-gray-600 font-semibold">نقاط الولاء</th>
                <th className="text-center px-4 py-3 text-gray-600 font-semibold">الحجوزات</th>
                <th className="text-center px-4 py-3 text-gray-600 font-semibold">الحالة</th>
                <th className="text-center px-4 py-3 text-gray-600 font-semibold">تاريخ التسجيل</th>
                <th className="text-center px-4 py-3 text-gray-600 font-semibold">إجراء</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {passengers.map((p) => (
                <tr key={p.id} className="hover:bg-gray-50 transition">
                  <td className="px-4 py-3">
                    <p className="font-semibold text-gray-800">{p.name}</p>
                    <p className="text-gray-400 text-xs">{p.email}</p>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{p.phone}</td>
                  <td className="px-4 py-3 text-center">
                    <span className="bg-yellow-100 text-yellow-700 text-xs px-2 py-1 rounded-full font-medium">
                      ⭐ {p.loyaltyPoints}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center font-bold text-gray-700">{p.bookingCount || 0}</td>
                  <td className="px-4 py-3 text-center">
                    <span className={`text-xs px-2 py-1 rounded-full font-medium ${p.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'}`}>
                      {p.isActive ? 'نشط' : 'موقوف'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center text-gray-400 text-xs">
                    {new Date(p.createdAt).toLocaleDateString('ar-SA')}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <button onClick={() => toggleStatus(p.id, p.isActive)}
                      className={`text-xs px-3 py-1 rounded-lg ${p.isActive ? 'bg-red-100 text-red-600 hover:bg-red-200' : 'bg-green-100 text-green-700 hover:bg-green-200'}`}>
                      {p.isActive ? 'إيقاف' : 'تفعيل'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          </div>
          {/* Pagination */}
          <div className="px-4 py-3 border-t flex items-center justify-between text-sm text-gray-500">
            <span>صفحة {page} من {Math.ceil(total / LIMIT) || 1}</span>
            <div className="flex gap-2">
              <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}
                className="px-3 py-1 rounded border disabled:opacity-40 hover:bg-gray-50">السابق</button>
              <button onClick={() => setPage((p) => p + 1)} disabled={page * LIMIT >= total}
                className="px-3 py-1 rounded border disabled:opacity-40 hover:bg-gray-50">التالي</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PassengersPage;
